import React from 'react';
import classNames from 'classnames';
import { Button as AntButton } from 'antd';
import type { ButtonProps as AntdButtonProps } from 'antd';
import cn from './styles.module.scss';

export enum ButtonType {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Icon = 'icon',
  OutlineIcon = 'outlineIcon',
  Danger = 'danger',
  Link = 'link',
}

export interface ButtonPropsType extends Omit<AntdButtonProps, 'type'> {
  type?: ButtonType,
  classes?: {
    buttonContainer?: string,
    button?: string,
  },
}

export const Button = React.forwardRef<HTMLButtonElement | HTMLAnchorElement, ButtonPropsType>(({
  onClick,
  type = ButtonType.Primary,
  className,
  disabled,
  children,
  size = 'large',
  ...props
}, ref) => (
  <AntButton
    ref={ref}
    size={size}
    type={type === ButtonType.Link ? 'link' : 'default'}
    disabled={disabled}
    onClick={onClick}
    className={classNames(
      cn.button,
      cn.buttonContainer,
      cn.customButton,
      cn[type],
      {
        [cn.disabled]: disabled,
      },
      className,
    )}
    {...props}
  >
    {children}
  </AntButton>
));

Button.displayName = 'Button';
